import { html, LitElement, type TemplateResult } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { type Ulid } from "../../../models/ulid.ts";
import { type AppStore } from "../app-store.ts";
import "../dui/menu/dui-menu.ts";
import "../dui/menu/dui-menu-item.ts";
import "../dui/button/dui-button.ts";
import "../dui/icon/dui-icon.ts";
import "../dui/hstack/dui-hstack.ts";
import "../dui/alert-dialog/dui-alert-dialog.ts";
import "../dui/alert-dialog/dui-alert-dialog-popup.ts";
import "../dui/alert-dialog/dui-alert-dialog-title.ts";
import "../dui/alert-dialog/dui-alert-dialog-description.ts";
import "../dui/alert-dialog/dui-alert-dialog-close.ts";

@customElement("project-menu")
export class ProjectMenuElement extends LitElement {
  @property({ attribute: false })
  accessor projectId: Ulid | undefined = undefined;

  @property({ attribute: false })
  accessor store: AppStore | undefined = undefined;

  @state()
  accessor #showDialog = false;

  #onOpenDeleteAlert = (): void => {
    this.#showDialog = true;
  };

  #onDialogOpenChange = (event: CustomEvent<{ open: boolean }>): void => {
    if (!event.detail.open) {
      this.#showDialog = false;
    }
  };

  #onConfirmDelete = (): void => {
    if (this.projectId) {
      this.store?.send({
        type: "delete-project",
        value: this.projectId,
      });
      this.#showDialog = false;
    }
  };

  override render(): TemplateResult {
    return html`
      <dui-menu>
        <dui-button slot="trigger" variant="ghost" square size="sm">
          <dui-icon icon="more_horiz"></dui-icon>
        </dui-button>
        <dui-menu-item variant="danger" @click="${this.#onOpenDeleteAlert}"
          >Delete project</dui-menu-item
        >
      </dui-menu>
      <dui-alert-dialog
        .open="${this.#showDialog}"
        @alert-dialog-open-change="${this.#onDialogOpenChange}"
      >
        <dui-alert-dialog-popup>
          <dui-alert-dialog-title>Delete project</dui-alert-dialog-title>
          <dui-alert-dialog-description>
            Are you sure you want to delete this&nbsp;project?
          </dui-alert-dialog-description>
          <dui-hstack gap="2">
            <dui-alert-dialog-close>
              <dui-button variant="outline">Cancel</dui-button>
            </dui-alert-dialog-close>
            <dui-alert-dialog-close>
              <dui-button
                variant="destructive"
                autofocus
                @click="${this.#onConfirmDelete}"
                >Delete</dui-button
              >
            </dui-alert-dialog-close>
          </dui-hstack>
        </dui-alert-dialog-popup>
      </dui-alert-dialog>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "project-menu": ProjectMenuElement;
  }
}
